import * as React from 'react';
import { Card, Button, InputGroup, Form, Accordion } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './SettingsGeneral.scss';
import Field from '../../Shared/Wizard/Field/Field';

function SettingsGeneral(props) {
    const t = useTranslate();  
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const [settings, setSettings] = useState(props.settingProps);
    
    async function handleSaveSettingsGeneral() {
        axios.put('/api/settings/' + settings["_id"], {
            confirmationTextSms: settings["confirmationTextSms"],
            confirmationTextEmail: settings["confirmationTextEmail"],
            invoicingValue: settings["invoicingValue"]
        }, {
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            if (response.status == 200) {
                notifySuccess(t("settings.toast_savesuccess"));
            }
            if (props.onSettingsGeneralChanged != undefined) {
                props.onSettingsGeneralChanged(response.data);
            }
            
        });
    }

    useEffect(() => {
         setSettings(props.settingProps);
    }, [props]);

    return(
    <div>
        <Card>
            <Accordion.Toggle className="clickable" as={Card.Header} eventKey="4">
                <h4 className="header-title">{t("settings.defaulttexts.title")}</h4>
                <p>{t("settings.defaulttexts.description")}</p>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="4">
                <Card.Body>
                    <p>{t("settings.defaulttexts.codewords.info")}</p>
                    <ul>
                        <li>[bookings] - {t("settings.defaulttexts.codewords.list.bookings")}</li>
                        <li>[guest-firstname] - {t("settings.defaulttexts.codewords.list.firstname")}</li>
                        <li>[guest-lastname] - {t("settings.defaulttexts.codewords.list.lastname")}</li>
                        <li>[guest-organisation] - {t("settings.defaulttexts.codewords.list.organisation")}</li>
                    </ul>
                    
                    <h3>{t("settings.defaulttexts.sms.title")}</h3>
                    <div className="settingsarea">
                        <Field
                            type="textarea"
                            value={settings?.confirmationTextSms ?? ""}
                            onChange={val => {
                                setSettings({ ...settings, "confirmationTextSms": val });
                            }}
                            options={{
                                rows: 10
                            }}
                        ></Field>
                    </div>
                    <hr />
                    <h3>{t("settings.defaulttexts.email.title")}</h3>
                    <div className="settingsarea">
                        <Field
                            type="textarea"
                            value={settings?.confirmationTextEmail ?? ""}
                            onChange={val => {
                                setSettings({ ...settings, "confirmationTextEmail": val });
                            }}
                            options={{
                                rows: 10
                            }}
                        ></Field>
                    </div>
                    <Button className="savesettingsBtn savebtn" style={{ marginBottom: "20px" }} disabled={props.inheriting} onClick={handleSaveSettingsGeneral}>{props.inheriting ? t("settings.saveinherited") : t("settings.save")}</Button>
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    </div>
       
    );
}
 
export default SettingsGeneral;